import { useState } from "react";
import Slider from "react-slick";
import "../styles/Home.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { FaTags, FaLightbulb, FaUser, FaCube, FaPalette } from "react-icons/fa";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import aboutImg from "../assets/about.jpeg";

const sliderSettings = {
  dots: false,
  infinite: true,
  speed: 500,
  slidesToShow: 3,
  slidesToScroll: 1,
  arrows: true,
  responsive: [
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
      },
    },
  ],
};

const kitchenImages = [
  
  "/kitchen/kitchen1.jpeg",
  "/kitchen/kitchen2.jpeg",
  "/kitchen/kitchen3.jpeg",
  "/kitchen/kitchen4.jpeg",
  "/kitchen/kitchen5.jpeg",
  "/kitchen/kitchen6.jpeg",
  "/kitchen/kitchen7.jpeg",
  "/kitchen/kitchen8.jpeg",
  "/kitchen/kitchen9.jpeg",
  "/kitchen/kitchen10.jpeg",
  "/kitchen/kitchen11.jpeg",
  "/kitchen/kitchen12.jpeg",
  "/kitchen/kitchen13.jpeg",
  "/kitchen/kitchen14.jpeg",
  "/kitchen/kitchen15.jpeg",
  "/kitchen/kitchen16.jpeg",
  "/kitchen/kitchen17.jpeg",
];




function Home() {
  const galleryImages = [
  "https://images.unsplash.com/photo-1600585154340-be6161a56a0c",
  "https://images.unsplash.com/photo-1556911220-bff31c812dba",
  "https://images.unsplash.com/photo-1505693416388-ac5ce068fe85",
  "https://images.unsplash.com/photo-1584622650111-993a426fbf0a",
  "https://images.unsplash.com/photo-1600210492486-724fe5c67fb0",
];

const [currentSlide, setCurrentSlide] = useState(0);

const prevSlide = () => {
  setCurrentSlide(
    currentSlide === 0 ? galleryImages.length - 1 : currentSlide - 1
  );
};

const nextSlide = () => {
  setCurrentSlide(
    currentSlide === galleryImages.length - 1 ? 0 : currentSlide + 1
  );
};
    const [activeTab, setActiveTab] = useState("before");
  return (
    <div>

      {/* ===== HERO SECTION ===== */}
      <section className="hero">
        <div className="hero-overlay">
          <div className="hero-content">
            <h1>
              Welcome to Onsite Interiors <br />
              <span>by Sneha Maurya</span>
            </h1>
            <div className="hero-buttons">

        <a href="tel:+916280289442" className="hero-btn">
          Call Now
        </a>

        <a 
          href="https://wa.me/916280289442"
          className="hero-btn whatsapp"
          target="_blank"
          rel="noopener noreferrer"
        >
          WhatsApp
        </a>

      </div>

    </div>
  </div>
</section>


{/* ===== HOW IT WORKS SECTION ===== */}

<section className="how-it-works">
  <div className="container">

    <h2>Welcome to Onsite Interiors a Brand of M.Star Services </h2>

    <p className="subtitle">
      Onsite Interior, a trusted brand of M. Star Services, operates with GSTIN: 03LMWPS6978L2ZI.
We proudly serve clients through our offices in Zirakpur (Chandigarh) and Naubasta ( Kanpur )
    </p>

    <div className="video-grid">

  <iframe
    src="https://www.youtube.com/embed/tpkZ9HSqTmM"
    title="video1"
    allowFullScreen
  ></iframe>

  <iframe
    src="https://www.youtube.com/embed/JDLJh5iices"
    title="video2"
    allowFullScreen
  ></iframe>

  <iframe
    src="https://www.youtube.com/embed/2mGM7IGgz7g"
    title="video3"
    allowFullScreen
  ></iframe>

  <iframe
    src="https://www.youtube.com/embed/BA04Wmu99zI"
    title="video4"
    allowFullScreen
  ></iframe>

  <iframe
    src="https://www.youtube.com/embed/R3OEJxDpZyY"
    title="video5"
    allowFullScreen
  ></iframe>

  <iframe
    src="https://www.youtube.com/embed/nJ-FhQWsIm0"
    title="video6"
    allowFullScreen
  ></iframe>

</div>

  </div>
</section>

{/* ===== ABOUT SECTION ===== */}

<section className="about-section">

<div className="container">

<h2 className="section-title">
Visit Our Offices
</h2>

<p className="section-subtitle">
 Connecting You to Quality Interiors
</p>

{/* STATS ROW */}
<div className="about-stats">

<div className="stat-box">
<h3>Chandigarh Office</h3>
<p>SCF No 8 , Near Masjid , Baltana , Zirakpur , Punjab , 140604</p>
</div>

<div className="stat-box">
<h3>Kanpur Office</h3>
<p>1A/2 AWAS VIKAS HANSPURAM , Oppoiste Metro Station ,  NAUBASTA KANPUR NAGAR 208021</p>
</div>

<div className="stat-box">
<h3>Upcomming Office</h3>
<p>Awadpuri , Bhopal</p>
</div>

<div className="stat-box">
<h3>Upcomming Office</h3>
<p>Kottayam , Kerala</p>
</div>

</div>

{/* CONTENT SECTION */}
<div className="about-content-wrapper">

<div className="about-image">
  <img src={aboutImg} alt="About Us" />
</div>

<div className="about-text-content">

<h3>About Onsite Interior</h3>

<p>
 Onsite Interior is a brand of M. Star Services, with its registered and head office located in Zirakpur, Punjab, and a brand office in Kanpur, Uttar Pradesh.

Led by Sneha Maurya and her dedicated team, Onsite Interior is committed to delivering high-quality interior solutions with professionalism and precision.

</p>

<p>
We offer flexible interior services — both on labour rate and with complete material solutions — tailored to meet diverse client needs.

We specialize in modular kitchen design and execution, creating functional, stylish, and modern kitchen spaces that enhance your lifestyle.
</p>

<button className="about-btn">
Discover More
</button>

</div>

</div>

</div>

</section>
      


{/* ===== POPULAR INTERIOR DESIGNS ===== */}

<section className="popular-designs">
  <div className="container">
    <h2>Popular Interior Designs for Every Space</h2>

    <p className="design-subtitle">
      Discover stunning ideas for kitchens, bedrooms, living rooms and bathrooms.
      Get inspired by modern styles and create a home that truly reflects your personality.
    </p>

    {/* ===== KITCHEN ===== */}
    <h3 className="room-title"> Our Project </h3>
    <div className="design-grid">
      {kitchenImages.map((img, index) => (
        <div key={index} className="grid-item">
          <img src={img} alt="Kitchen Design" />
        </div>
      ))}
    </div>

  </div>
</section>


{/* ===== GET IN TOUCH SECTION ===== */}

<section className="contact-section">

  <div className="container">

    <h2 className="contact-title">Get In Touch With Us</h2>

    <p className="contact-subtitle">
      Have a project in mind? We'd love to hear from you.
      Visit our studio or send us your details and our team will get back to you shortly.
    </p>

    <div className="contact-wrapper">

      {/* ===== ALL MAPS ===== */}
      <div className="contact-maps">

        <iframe
          src="https://maps.google.com/maps?q=Chandigarh&z=13&output=embed"
          title="Chandigarh Map"
        ></iframe>

        <iframe
          src="https://maps.google.com/maps?q=Kanpur&z=13&output=embed"
          title="Kanpur Map"
        ></iframe>

        <iframe
          src="https://maps.google.com/maps?q=Bhopal&z=13&output=embed"
          title="Bhopal Map"
        ></iframe>

        <iframe
          src="https://maps.google.com/maps?q=Kerala&z=13&output=embed"
          title="Kerala Map"
        ></iframe>

      </div>

      {/* ===== FORM ===== */}
      <div className="contact-form">
        <form>

          <div className="form-group">
            <label>Name</label>
            <input type="text" placeholder="Enter your name" required />
          </div>

          <div className="form-group">
            <label>Contact Number</label>
            <input type="tel" placeholder="Enter your phone number" required />
          </div>

          <div className="form-group">
            <label>Location</label>
            <input type="text" placeholder="Enter your location" required />
          </div>

          <button type="submit" className="contact-btn">
            Send Message
          </button>

        </form>
      </div>

    </div>

  </div>

</section>

    </div>
  );
}

export default Home;